// package
import { ref, watch } from '@vue/composition-api';

/**
 * [function]
 * Em determinadas listagens, é necessário
 * gerar diferentes z-index's, de forma a que
 * seja possível que os filhos consigam ficar
 * por cima dos tios.
 *
 * @param {Object} state
 * @since 1.0.0
 * @category função
 * @autor Tiago Martinho
 *
*/
const generateZindex = state => {
    const watcher = ref( state?.questions || state.value );
    const zIndexes = ref( [] );

    watch( () => watcher.value,
        newArray => {
            zIndexes.value = [];
            const { length } = newArray;

            for ( let i = length; i > 0; i-- )
                // eslint-disable-next-line
                zIndexes.value.push( i );

            return zIndexes.value;
        }, {
            immediate: true
        });

    return zIndexes;
};

export default generateZindex;